import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {CommonService} from 'src/app/shared/utils/common.service';
import {moduloHorasExtras} from "../diccionarios/horas-extrasModulo";
import {FechaCorteModel} from "../model/fechaCorte.model";


@Injectable({
  providedIn: 'root'
})
export class ParametrizacionFechaCorteService {

  diccionarioModulo: any;
  url: string;

  constructor(
    private http: HttpClient,
    private _util: UtilsService,
    private _commom: CommonService
  ) {
    this.diccionarioModulo = moduloHorasExtras;
    this.url = this._util.getUrlHorasExtra();
  }

  getAll() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.parametrizacion.fechaCorte.getAll);
  }

  guardarFechaCorte(fechaCorte: FechaCorteModel) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.parametrizacion.fechaCorte.create + '', fechaCorte);
  }

  actualizarFechaCorte(fechaCorte: FechaCorteModel) {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioModulo.url.parametrizacion.fechaCorte.update + fechaCorte.id + '', fechaCorte);
  }

  borrarFechaCorte(fechaCorte: FechaCorteModel) {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioModulo.url.parametrizacion.fechaCorte.delete + fechaCorte.id + '');
  }

}
